"use strict";

/**
 * Testing environment overrides
 */
export default {
    // General
    ENVIRONMENT: 'testing',
    BASE_URL: 'https://web-cr-vmest-test-ne.sf.vubiquity.com',

    // API
    PROXY_API_URL: 'https://api-cr-vmest-test-ne.sf.vubiquity.com',
    // VUB_API_URL: 'https://api-vu-test-ne-sf-vm.akamaized.net',
    VUB_API_URL: 'https://api-vu-test-ne.sf.vubiquity.com',
    VUB_LOGWATCH_URL: 'https://logwatch-vu-test-ne.sf.vubiquity.com',
    VUB_LICENSOR_URL: 'https://licensor-vu-test-ne.sf.vubiquity.com',

    // Identity
    GA_TRACKING_ID: 'UA-72605224-7',
    STRIPE_API_PK: 'pk_test_BYXYqlTOJbptxjmNjRApeedv',
    RE_CAPTCHA_SITE_KEY: '6LeDNBAUAAAAAHcLf7KezKQk0GHOXikNuNFohuR1',
    IDENTITY_SECURITY_KEY: "610622d3ac910a116080e2c8d8263cb5514556f14f16150af0e66a2d3478b346",

    // VISION 360
    VISION360_API_URL: 'https://dev.api.vu-vis360.co.uk/v1/',
    VISION360_AUTH_KEY: 'V!s!0n36o',

    //tile popup bubble debug
    // development variable is added for debugging in order to not remove popup element from DOM
    TILE_POPUP_BUBBLE_DEBUG_ENABLED: false
};
